export const headerImage = require('../assets/group_header.png')
export const vectorImg = require('../assets/image_Vector.png')
export const warningImage = require('../assets/delete-icon.png')
export const defaultAvatar = require('../assets/avatar.png')